import React from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { NotificationContainer } from '../ErrorNotification';
import { ErrorNotificationProvider } from '../../contexts/ErrorNotificationContext';
import errorHandlingSetup from '../../utils/errorHandlingSetup';

interface Props {
  children: React.ReactNode;
}

const ErrorHandlingIntegration: React.FC<Props> = ({ children }) => {
  React.useEffect(() => {
    errorHandlingSetup.initialize();
  }, []);

  return (
    <ErrorNotificationProvider>
      <ErrorBoundary>
        {children}
        <NotificationContainer position="top-right" maxNotifications={5} />
      </ErrorBoundary>
    </ErrorNotificationProvider>
  );
};

export default ErrorHandlingIntegration;
